import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useGetGatewayList } from "../../../lib/queries/queriesAndMutations";
import Buttons from "../../Buttons";
import Loader from "../../shared/Loader";
import Pagination from "../../shared/Pagination";
import Hint from "../Hint";
import GatewayCard from "./GatewayCard";

const GatewayList = () => {
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  const type = useSelector((store) => store.bussinessSlice.type);
  const businessId = useSelector((store) => store.bussinessSlice?.data?.business?.id);

  const onPageChange = useCallback((page) => setCurrentPage(page), []);

  const {
    data: gatewayList,
    isPending,
    refetch,
  } = useGetGatewayList({
    type,
    businessId,
    currentPage,
    pageSize,
  });

  const handleNewAccount = useCallback(() => navigate("/gateway/new"), [navigate]);

  if (isPending) {
    return (
      <div className="w-full h-full flex-center min-h-[400px] ">
        <Loader />
      </div>
    );
  }

  return (
    <>
      {gatewayList?.data.count > 0 ? (
        <div className="w-full  md:p-1 ">
          <div className="w-full flex flex-col items-end  p-2 md:p-2 rounded-v-lg gap-2">
            <div className="w-full flex justify-between items-center">
              <div onClick={handleNewAccount}>
                <Buttons
                  btnStyleparam={"mainbutton"}
                  fontsize={"dashboard"}
                  bgcolor={"primary"}
                  txtcolor={"primary"}
                  children={"درگاه جدید"}
                  lefticon={false}
                  righticon={false}
                  borders={"secondary"}
                  bRadius={"xl"}
                />
              </div>
            </div>

            <div className="w-full grid grid-cols-1  lg:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-4 gap-4 p-2 rounded-[16px]  ">
              {gatewayList?.data.count > 0 ? (
                gatewayList?.data.items.map((item, index) => (
                  <GatewayCard
                    key={index}
                    rowData={item}
                    index={index}
                    refetch={refetch} // Pass the refetch function
                  />
                ))
              ) : (
                <p>آیتمی وجود ندارد ...</p>
              )}
            </div>
          </div>

          <div className="w-full bg-neutral-10 rounded-v-lg mt-2">
            <Pagination
              onPageChange={onPageChange}
              totalCount={gatewayList?.data?.count || 0}
              siblingCount={1}
              currentPage={currentPage}
              pageSize={pageSize}
              className="bg-primary-40"
            />
          </div>
        </div>
      ) : (
        <div className="w-full h-full flex justify-center items-center ">
          <div className="flex flex-col  gap-6 p-6 bg-white max-w-[700px]   rounded-xl shadow-md w-fit">
            <Hint
              hintStyle={"entry"}
              response={"mobile"}
              hintImage={true}
              title={"به بخش درگاه ها خوش آمدید!"}
              entry={"flex justify-center items-center"}
            >
              <p className="flex justify-center items-center mb-4">
                هنوز درگاهی برای کسب و کار شما ایجاد نشده است.
                <br /> برای افزودن اولین درگاه، کافی است بر روی دکمه زیر کلیک نمایید و ادامه فرایند را طی
                کنید.
              </p>
              <div onClick={handleNewAccount}>
                <Buttons
                  btnStyleparam={"mainbutton"}
                  fontsize={"dashboard"}
                  bgcolor={"primary"}
                  txtcolor={"primary"}
                  children={"افزودن درگاه جدید"}
                  lefticon={false}
                  righticon={false}
                  borders={"secondary"}
                  bRadius={"xl"}
                />
              </div>
            </Hint>
          </div>
        </div>
      )}
    </>
  );
};

export default GatewayList;
